export {AuthenticationModule} from './core/authentication.module';
export {AuthenticationService} from './core/authentication.service';
export {UserDataEntity} from './core/models/user-data-entity.type';